import { Game, GameSubscription } from 'services/api/definitions/game.definitions';

import type { AboutGameProps } from 'components/@game-detail/About/AboutGame/AboutGame';

export const mapGameDetails = (game: Game | GameSubscription): AboutGameProps => ({
  title: game.name,
  description: game.description,
  // Structure is [{ "provider": "NewCom" }, { "age": "16+" }]
  specifications: game.metadata
    .filter(m => !!Object.entries(m).length)
    .map(m => {
      const data = Object.entries(m)[0];
      return {
        id: data[0],
        label: data[0],
        value: data[1],
      };
    }),
  images: game.exampleImages.map((image, idx) => ({
    src: image,
    alt: `${game.name} example image ${idx}`,
  })),
});
